<template>
  <div v-if="station">
    <l-marker :lat-lng="station.location" :icon="stationActiveIcon">
      <l-popup :content="`<h3>${station.name}</h3>`" />
    </l-marker>

    <l-circle
      v-for="radius in [1000000, 2000000, 3000000]"
      :key="radius"
      :lat-lng="station.location"
      :radius="radius"
      :weight="radius === 3000000 ? 3 : 2"
      :opacity="0.6"
      :fillOpacity="radius < 3000000 ? 0.1 : 0"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { LMarker, LPopup, LCircle } from "vue2-leaflet";
import { icon } from "leaflet";

defineProps({
  station: {
    type: Object,
    required: true
  }
});

const stationActiveIcon = ref(
  icon({
    iconUrl: `${process.env.VUE_APP_STATIC_HOST}/station_icon_green.png`,
    iconSize: [32, 32],
    iconAnchor: [16, 16]
  })
);
</script>